'use strict';

import template from '../../templates/employees/Employee.ejs';
import moment from 'moment';

module.exports = Backbone.View.extend({
    tagName: 'tr',
    events: {
        'click .js-login': 'loginAsEmployee'
    },

    initialize() {
        this.model.fetchUser()
            .then(u => this.user = u)
            .then(() => this.model.fetchCompany())
            .then(c => this.company = c)
            .then(() => this.render());
    },

    render() {
        let displayLogin = this.user ? true : false;
        this.$el.html(template({
            model: this.model,
            user: this.user,
            company: this.company,
            displayLogin: displayLogin,
            moment: moment
        }));
        return this;
    },

    loginAsEmployee(ev) {
        window.open(`/?employee=${this.model.get('objectId')}`, '_blank');
        ev.preventDefault();
        return false;
    }
});



// WEBPACK FOOTER //
// ./app/adminManager/views/employees/Employee.js